import DAY_COLORS from 'eds-settings/themes/day/colors.json';
import { genTheme } from '../_internal/utils';

export default genTheme(null, DAY_COLORS);
